// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COMPLAINTS_REPORTED_BY = "nahl\u00e1sila";
